export default __webpack_public_path__ + "static/media/MONUSCO_kItshanga_town_center_destoryed.e595ed3c.jpg";